import React, { ReactElement, ReactNode } from 'react';
import { ProjectOtherNameDTO, ProjectOtherPartnerDTO } from '../../../../api/core/models';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { getDefaultProjectOtherPartner } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { InputGroup } from '../layout/InputGroup';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { Panel } from '../layout/Panel';

interface ProjectOtherPartnersProps {
  checkPermission: CheckPermissionFunction;
  projectOtherPartners: ProjectOtherNameDTO[];
  onChange: (projectOtherPartners: ProjectOtherNameDTO[]) => void;
  validation: ValidationResult;
  label: string;
  autoFocus: boolean;
}

export function ProjectOtherPartners(props: ProjectOtherPartnersProps): ReactNode {
  return (
    <Panel title={props.label} toggleable={true}>
      <MultiInputControls<ProjectOtherNameDTO>
        lines={props.projectOtherPartners}
        onChange={props.onChange}
        canEdit={props.checkPermission().canWrite}
        renderLines={(projectOtherPartner: ProjectOtherPartnerDTO, onChange2: (_projectOtherPartners: ProjectOtherPartnerDTO) => void, actions: Actions, idx: number): ReactElement => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledInputText
                id={`otherPartner${idx}`}
                autoFocus={props.autoFocus}
                value={projectOtherPartner.otherPartner}
                permissions={props.checkPermission('other_partner')}
                validation={props.validation?.children[idx]?.fields?.other_partner}
                onChange={(otherPartner: string): void => onChange2({...projectOtherPartner, otherPartner})}
                label={`${props.label}.attr.otherPartner`}

              />
            </InputGroup>
          );
        }}
        addNew={(row: ProjectOtherPartnerDTO[]): number => row.push(getDefaultProjectOtherPartner())}/>
    </Panel>
  );
}
